import {ChangeDetectionStrategy, Component,} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {AngularNodeViewComponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/ngx-tiptap/src/lib/node-view.component";

const debug = initDebugger('RiktekstPdfSideskiftKomponent');

/** Komponent som rendrer 'pdf-sideskift' node i tiptap editor.
 * MERK at denne ikke kan benyttes utenfor tiptap editor */
@Component({
    selector: 'riktekst-redigering-pdf-sideskift',
    template: '<span></span><mat-icon>insert_page_break</mat-icon><span></span>',
    styleUrl: 'pdf-sideskift.scss',
    imports: [
        MatIcon
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringPdfSideskiftKomponent extends AngularNodeViewComponent {
}
